module.exports = __webpack_public_path__ + "static/img/szty.bf38723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/szty.jpg
// module id = S2cS
// module chunks = 11